export const PRE_GET_CREATOR_PROFILE = 'containers/CreatorProfilePage/PRE_GET_CREATOR_PROFILE';
export const GET_CREATOR_PROFILE_SUCCESS = 'containers/CreatorProfilePage/GET_CREATOR_PROFILE_SUCCESS';
export const GET_CREATOR_PROFILE_ERROR = 'containers/CreatorProfilePage/GET_CREATOR_PROFILE_ERROR';
export const PRE_GET_CREATOR_DATA = 'containers/CreatorProfilePage/PRE_GET_CREATOR_DATA';
export const GET_CREATOR_DATA_SUCCESS = 'containers/CreatorProfilePage/GET_CREATOR_DATA_SUCCESS';
export const GET_CREATOR_DATA_ERROR = 'containers/CreatorProfilePage/GET_CREATOR_DATA_ERROR';
export const CHANGE_PAGE = 'containers/CreatorProfilePage/CHANGE_PAGE';
export const FILTER_PER_PAGE = 'containers/CreatorProfilePage/FILTER_PER_PAGE';
